// DO NOT USE THIS COMPONENT, IT WILL BE REMOVED
import React, { useMemo, useContext, useEffect, useState } from 'react';
import { CheckboxGroup } from './withFormProps';
import { useField, ComparatorContext } from '@kizi/comparator-core';
import { FormFieldHOCProps } from '../..';
import { CheckboxGroupProps } from '@kizi/shared-components';
import { SkeletonBlock } from '../../Skeletons';
import { Div } from '@kizi/core-components';
import { useFieldTracking } from '../../../utils/hooks';

export interface CheckboxItem {
  label: any;
  value: any;
  dependsOn?: string;
}
export interface CheckboxGroupWrapperProps
  extends FormFieldHOCProps,
    CheckboxGroupProps {
  value?: string;
  options: CheckboxItem[];
}

export const CheckboxGroupWrapper: React.FC<CheckboxGroupWrapperProps> = ({
  options = [],
  ...restProps
}) => {
  const _field = useField(restProps._fieldName);
  const {trackEvent} = useFieldTracking();
  const parsedFieldValue = _field?.value ? JSON.parse(_field.value as string) : [];
  let checkedValue = '';
  let checked = false;

  const handleChange = (selected) => {
    if (selected.length > parsedFieldValue.length) {
      checked = true;
      checkedValue = selected[selected.length - 1];
    } else {
      checkedValue = parsedFieldValue.filter(e=> {
        return !selected.includes(e);
      })[0];
    }

    trackEvent(_field?.name)({
      type: 'click',
      target: {
        checked,
        value: checkedValue,
        localName: 'checkbox',
      },
      ga4event: 'filter_usage',
    });
    _field?.set({ value: JSON.stringify(selected) });
  }
  const selectedOptions =
    _field?.value !== undefined ? parsedFieldValue : [];

  const filteredOptions = useMemo(() => {
    return options.filter((filteredOption) => {
      const dependedValue = filteredOption.dependsOn;
      return dependedValue
        ? selectedOptions.some(
            (selectedOption) => selectedOption === dependedValue
          )
        : true;
    });
  }, [selectedOptions, options]);

  if (!_field) return null;

  return useMemo(
    () => (
      <CheckboxGroup
        {...restProps}
        onChange={handleChange}
        selectedOptions={selectedOptions}
        options={filteredOptions}
      />
    ),
    [options, selectedOptions, handleChange]
  );
};

export interface CheckboxGroupWrapperApiProps
  extends Omit<CheckboxGroupWrapperProps, 'options'> {
  handler: string;
  optionsFieldName: string;
}

export const CheckboxGroupWrapperApi: React.FC<CheckboxGroupWrapperApiProps> =
  ({ handler, optionsFieldName, ...restProps }) => {
    const storedOptions = useField(optionsFieldName);
    const { api } = useContext(ComparatorContext);

    const storedOptionsValue: CheckboxItem[] =
      storedOptions?.hasOwnProperty('value') &&
      storedOptions.value !== undefined
        ? JSON.parse(storedOptions.value as string)
        : [];

    const [options, setOptions] =
      useState<{ label: string; value: any }[]>(storedOptionsValue);

    useEffect(() => {
      if (!options.length) {
        api[handler]().then((res) => {
          setOptions(res);
          storedOptions?.set({
            value: JSON.stringify(res),
          });
        });
      }
    }, []);

    const RepeatableSection = () => (
      <Div display="flex" flexDirection="row">
        <SkeletonBlock
          width={20}
          height={23}
          marginBottom={15}
          marginRight={15}
        />
        <SkeletonBlock width={130} height={23} marginBottom={15} />
      </Div>
    );

    const skeletonPreview = (
      <Div>
        <SkeletonBlock width={120} height={23} marginBottom={15} />
        {new Array(5).fill(null).map((_, index) => (
          <RepeatableSection key={`rs_${index}`} />
        ))}
      </Div>
    );

    return useMemo(
      () =>
        options.length === 0 ? (
          skeletonPreview
        ) : (
          <CheckboxGroupWrapper {...restProps} options={options} />
        ),
      [options]
    );
  };
